export default {
  velt: {
    openPanel: 'Apri pannello commenti',
    closePanel: 'Chiudi pannello commenti',
    panel: 'Pannello commenti',
    tabs: 'Schede del pannello commenti',
    comments: 'Commenti',
    settings: 'Impostazioni e autorizzazioni',
    dragOrTapComment: 'Trascina per aggiungere un commento oppure tocca per visualizzare i commenti',
    assignComment: 'Assegna commento',
    markAsUnread: 'Segna come non letto',
    markAsRead: 'Segna come letto',
    unsubscribe: 'Annulla iscrizione',
    subscribe: 'Iscriviti',
    deleteThread: 'Elimina conversazione',
    editComment: 'Modifica commento',
    emptyPlaceholder: 'Lascia un feedback, fai una domanda o lascia una nota per i membri del tuo team',
    searchPlaceholder: 'Cerca commenti',
    commentPlaceholder: 'Commenta {page}',
    replyPlaceholder: 'Rispondi....',
    filterPages: 'Pagine',
    filterAuthor: 'Autore',
    filterTagged: 'Taggati',
    statusOpen: 'Aperto',
    statusResolved: 'Risolto',
    anonymous: 'Anonimo',
    settingsPanel: {
      title: 'Chi può commentare?',
      everyoneLabel: 'Tutti',
      restrictedLabel: 'Solo collaboratori invitati',
      emailsLabel: 'Email',
      emailsPlaceholder: 'Aggiungi un\'email e premi Invio',
    },
  },
}
